<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LC702Q/tc-custom/9781250120694.jpg?1730583788340" alt="This image is the cover for the book Chick and the Dead"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Chick and the Dead
      </h1>
      <p class="bookDescription body article font2">
        <b>A mortician explains the autopsy process—and what it can teach us about the living—with “a morbidly galloping parade of every possible kind of dead body” (<i>New York Times</i>).</b><br/><br/>Carla Valentine works with the dead. After studying forensics, she assisted pathologists with post-mortems for years before becoming the curator of the world’s most famous pathology museum. When it comes to death, she truly is an expert, and in this book she shares that expertise.<br/><br/>Using the most common post-mortem process as the backbone of the narrative, she takes us through the process of an autopsy while also describing the history and changing cultures of our relationship with the dead. The book is full of vivid insight into what happens to our bodies in the end. Each chapter considers an aspect of an autopsy alongside an aspect of Carla’s own life and work, and touches on some of the more controversial aspects of our feelings about death, including the relationship between sex and death and our attitudes toward human tissue collection.<br/><br/>Starting with the first cut, we move from external examination into the body itself, discovering more about the heart, stomach, and brain, and into dismembered and reconstructed bodies, at each stage taking a colorful detour into the question of what these things can teach us about the living. Join Carla on the journey from microscope-requesting nine-year-old to pathology educator and death engager at a Victorian museum (a journey made via around 5,000 autopsies) as she tells the story of exactly what it’s like to live a life immersed in death.<br/><br/><b>Praise for Carla Valentine’s <i>The Science of Murder</i></b><br/><br/>“A breezy and accessible look at the history of forensic science.” —<i>Publishers Weekly</i><br/><br/>“Utterly superb.” —Deanna Raybourn, <i>New York Times</i>–bestselling author of the Veronica Speedwell Mysteries
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carla Valentine
      </h2>
      
      <p class="authorDescription body article">CARLA VALENTINE has a certificate and diploma in Anatomical Pathology Technology and, during her eight-year mortuary career, continued her professional development by studying forensic anthropology at military college and taking part in skeletal excavations in Belgium and Venice. She writes and researches themes around sex and death on her blog entitled "The Chick and the Dead." She also runs a dating and networking site for death professionals called Dead Meet. She lives in the UK.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?72897b0a